<template>
  <div class="page-wrapper">
    <!-- =============== PC 端 =============== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.user_id"
            placeholder="赠送用户ID"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-input
            v-model="searchParams.give_id"
            placeholder="受赠用户ID"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.status"
            placeholder="审核状态"
            style="width: 220px; margin-right: 10px"
            clearable
          >
            <el-option label="待审核" :value="0" />
            <el-option label="审核成功" :value="1" />
            <el-option label="审核失败/用户取消" :value="2" />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="订单ID" prop="id" width="100" align="center" />
          <el-table-column label="赠送用户ID" prop="user_id" width="140" align="center" />
          <el-table-column label="受赠用户ID" prop="give_id" width="140" align="center" />
          <el-table-column label="赠送金额" prop="amount" width="120" align="center" />
          
          <el-table-column label="审核状态" width="200" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusColor(scope.row.status)">
                {{ getStatusName(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="备注" prop="remark" min-width="150" />
          
          <el-table-column label="操作" width="320" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="text"
                  icon="el-icon-view"
                  @click.stop="openPcDetail(scope.row)"
                  >查看详情</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-check"
                  @click.stop="auditOrder(scope.row.id, 1)"
                  v-if="Number(scope.row.status) == 0"
                  >审核通过</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-close"
                  @click.stop="auditOrder(scope.row.id, 2)"
                  v-if="Number(scope.row.status) == 0"
                  >审核驳回</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗：基础信息 + 赏品表格列表 -->
        <el-dialog
          title="赠礼详情"
          :visible.sync="pcDetailVisible"
          width="750px"
          append-to-body
        >
          <!-- 订单基础信息 -->
          <el-form :model="pcDetailBase" label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col span="12">
                <el-form-item label="订单ID"><span>{{ pcDetailBase.box_give_order_id }}</span></el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="审核状态">
                  <el-tag :type="getStatusColor(pcDetailBase.status)">
                    {{ getStatusName(pcDetailBase.status) }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="赠送用户ID"><span>{{ pcDetailBase.user_id }}</span></el-form-item>
              </el-col>
              <el-col span="12">
                <el-form-item label="受赠用户ID"><span>{{ pcDetailBase.give_id }}</span></el-form-item>
              </el-col>
              <el-col span="24">
                <el-form-item label="创建时间"><span>{{ pcDetailBase.created_at }}</span></el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div style="margin:16px 0 8px;font-weight:500">赠送赏品清单</div>
          <!-- 多条赏品表格 -->
          <el-table :data="pcDetailList" border stripe size="mini" max-height="320">
            <el-table-column label="赏品ID" prop="id" width="80" align="center" />
            <el-table-column label="赏品名称" prop="prize_name" width="120" align="center" />
            <el-table-column label="单价(元)" prop="prize_price" width="90" align="center" />
            <el-table-column label="数量" prop="prize_num" width="70" align="center" />
            <el-table-column label="等级" width="70" align="center">
              <template slot-scope="scope">{{ scope.row.prize_level == 1 ? '一阶' : '二阶' }}</template>
            </el-table-column>
            <el-table-column label="赏品图片" width="120" align="center">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.prize_image"
                  fit="cover"
                  style="width:60px;height:60px"
                  :preview-src-list="[scope.row.prize_image]"
                />
              </template>
            </el-table-column>
            <el-table-column label="原赏品ID" prop="old_prize_id" width="100" align="center" />
          </el-table>

          <div slot="footer">
            <el-button @click="pcDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- =============== 移动端 =============== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.user_id"
            placeholder="赠送用户ID"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <el-input
            v-model="searchParams.give_id"
            placeholder="受赠用户ID"
            clearable
            size="medium"
            style="margin-top:8px"
          />
          
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.status"
              placeholder="审核状态"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option label="待审核" :value="0" />
              <el-option label="成功" :value="1" />
              <el-option label="失败" :value="2" />
            </el-select>
          </div>
          
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
          </div>
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="title">订单：{{ item.id }}</div>
                <div class="meta">赏品：{{ item.prize_name || '未知' }}</div>
              </div>
              <el-tag :type="getStatusColor(item.status)" size="mini">
                {{ getStatusName(item.status) }}
              </el-tag>
            </div>
            <div class="card-body">
              <div>赠送ID：{{ item.user_id }}</div>
              <div>受赠ID：{{ item.give_id }}</div>
              <div>赏品价格：{{ item.prize_price }} 元</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileDetail(item)"
                >详情</el-button
              >
              <el-button
                size="mini"
                type="success"
                round
                @click.stop="auditOrder(item.id,1)"
                v-if="Number(item.status) == 0"
                >通过</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="auditOrder(item.id,2)"
                v-if="Number(item.status) == 0"
                >驳回</el-button
              >
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗：基础信息 + 多条赏品卡片循环 -->
        <el-dialog
          title="赠礼详情"
          :visible.sync="mobileDetailVisible"
          width="90%"
          append-to-body
        >
          <!-- 订单基础信息 -->
          <el-form :model="mobileDetailBase" label-width="100px" size="small">
            <el-form-item label="主订单ID"><span>{{ mobileDetailBase.box_give_order_id }}</span></el-form-item>
            <el-form-item label="赠送ID"><span>{{ mobileDetailBase.user_id }}</span></el-form-item>
            <el-form-item label="受赠ID"><span>{{ mobileDetailBase.give_id }}</span></el-form-item>
            <el-form-item label="状态">
              <el-tag :type="getStatusColor(mobileDetailBase.status)">
                {{ getStatusName(mobileDetailBase.status) }}
              </el-tag>
            </el-form-item>
            <el-form-item label="创建时间"><span>{{ mobileDetailBase.created_at }}</span></el-form-item>
          </el-form>

          <div style="margin:12px 0 8px;font-weight:500">赏品明细</div>
          <!-- 循环展示每一件赏品卡片 -->
          <div class="mobile-detail-card-list">
            <div class="mobile-detail-card" v-for="goods in mobileDetailList" :key="goods.id">
              <div class="d-flex gap-10">
                <el-image
                  :src="goods.prize_image"
                  style="width:70px;height:70px;border-radius:6px"
                  fit="cover"
                  :preview-src-list="[goods.prize_image]"
                />
                <div class="flex-1">
                  <div class="goods-name">{{ goods.prize_name }}</div>
                  <div class="goods-row">单价：{{ goods.prize_price }} 元 × {{ goods.prize_num }}</div>
                  <div class="goods-row">等级：{{ goods.prize_level == 1 ? '一阶' : '二阶' }}</div>
                  <div class="goods-row">赏品ID：{{ goods.id }} | 原ID：{{ goods.old_prize_id }}</div>
                </div>
              </div>
            </div>
          </div>

          <div slot="footer">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "UserGiveOrder",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        give_id: "",
        status: ""
      },
      // PC 弹窗
      pcDetailVisible: false,
      pcDetailBase: {}, // 订单基础信息
      pcDetailList: [], // 多条赏品明细数组
      // 移动端弹窗
      mobileDetailVisible: false,
      mobileDetailBase: {}, // 订单基础信息
      mobileDetailList: [] // 多条赏品明细数组
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      api.users.usersGiveOrder({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            // 修复：兼容旧语法，status 不存在则默认 0
            this.tableData = res.data.data.data.map(item => ({
              ...item,
              status: item.status !== undefined ? item.status : 0
            }));
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // PC 打开详情
    async openPcDetail(row) {
      const res = await api.users.usersGiveOrderDetail({ order_id: row.id });
      if (res.data.code == 1000 && Array.isArray(res.data.data)) {
        const list = res.data.data;
        this.pcDetailList = list;
        // 取第一条作为订单基础信息（共用赠送人/受赠人/主订单ID/状态/时间）
        this.pcDetailBase = list[0] || {};
      } else {
        this.pcDetailList = [];
        this.pcDetailBase = {};
      }
      this.pcDetailVisible = true;
    },

    // 移动端打开详情
    async openMobileDetail(row) {
      const res = await api.users.usersGiveOrderDetail({ order_id: row.id });
      if (res.data.code == 1000 && Array.isArray(res.data.data)) {
        const list = res.data.data;
        this.mobileDetailList = list;
        this.mobileDetailBase = list[0] || {};
      } else {
        this.mobileDetailList = [];
        this.mobileDetailBase = {};
      }
      this.mobileDetailVisible = true;
    },

    // 审核订单
    async auditOrder(order_id, status) {
      const txt = status == 1 ? "通过" : "驳回";
      const confirm = await this.$confirm(`确定${txt}该订单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: status == 1 ? "success" : "warning",
      }).catch(() => false);
      if (!confirm) return;

      this.loading = true;
      try {
        await api.users.usersAuditGiveOrder({ order_id, status });
        this.getList();
      } finally {
        this.loading = false;
      }
    },

    // 状态文字
    getStatusName(status) {
      const map = { 0: "待审核", 1: "审核成功", 2: "审核失败/用户取消" };
      return map[Number(status)] || "未知";
    },

    // 状态颜色
    getStatusColor(status) {
      const map = { 0: "info", 1: "success", 2: "danger" };
      return map[Number(status)] || "";
    },

    // 重置
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        give_id: "",
        status: ""
      };
      this.getList();
    },

    // 分页
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    }
  },
};
</script>

<style scoped>
/* =============== PC 样式 =============== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* =============== 移动端样式 =============== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
}

/* 移动端弹窗赏品卡片 */
.mobile-detail-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-detail-card {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 10px;
}
.d-flex {
  display: flex;
}
.gap-10 {
  gap: 10px;
}
.flex-1 {
  flex: 1;
}
.goods-name {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
}
.goods-row {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
</style>


// WEBPACK FOOTER //
// src/pages/user/giveOrder.vue